// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-section {
  margin-bottom: 0;
}

/* Overall page: allow horizontal scroll on small displays instead of squashing */
.report-table-scroll {
  overflow-x: auto;
  margin-bottom: 1rem;
  -webkit-overflow-scrolling: touch;
}

.report-table-scroll .report-table {
  margin-bottom: 0;
}

.overall-table-block {
  position: relative;
  margin-bottom: 1rem;
}

.overall-table-block .report-table-scroll {
  margin-bottom: 0;
}

.overall-table-block .report-table {
  width: auto;
  border-radius: 0 0 var(--radius) var(--radius);
}

.overall-sticky-header {
  box-sizing: border-box;
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  max-width: 100%;
  background: var(--bg-subtle);
  border: 1px solid var(--border);
  border-bottom: none;
  border-radius: var(--radius) var(--radius) 0 0;
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.overall-sticky-header-name {
  box-sizing: border-box;
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  padding: 0.6rem 0.9rem;
  border-right: 1px solid var(--border);
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--text);
  cursor: pointer;
  white-space: normal;
  overflow-wrap: break-word;
}

.overall-sticky-header-scroll {
  flex: 1 1;
  overflow: hidden;
}

.overall-sticky-header-cols {
  display: flex;
  will-change: transform;
}

.overall-sticky-header-col {
  box-sizing: border-box;
  width: 170px;
  min-width: 170px;
  max-width: 170px;
  padding: 0.6rem 0.9rem;
  border-right: 1px solid var(--border);
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--text);
  text-align: left;
}

.overall-sticky-header-col:last-child {
  border-right: none;
}

/* Report warnings */
.report-warnings {
  background: var(--warning-bg);
  border: 1px solid var(--warning-border);
  border-radius: 6px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.85rem;
  color: var(--warning-text);
}

.report-warnings ul {
  margin: 0.4rem 0 0;
  padding-left: 1.25rem;
}

.report-warnings li {
  margin-bottom: 0.2rem;
}

.warning-table {
  font-weight: 600;
}

.warning-source {
  color: var(--warning-text);
  font-size: 0.75rem;
  margin-left: 0.5rem;
}

.report-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 1rem;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  overflow: hidden;
}

/* Overall page: align columns across multiple tables.
   First column (row name) has a fixed share; remaining columns split equally. */
.report-wide .report-table {
  table-layout: fixed;
  overflow: visible;
}

.report-wide .report-table-scroll {
  position: relative;
  max-width: 100%;
}
.report-wide .report-table th:first-child,
.report-wide .report-table td:first-child {
  position: sticky;
  left: 0;
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  z-index: 2;
  background: var(--bg-card);
  white-space: normal;
  overflow-wrap: break-word;
}

.report-wide .report-table thead th {
  position: sticky;
  top: 0;
  z-index: 4;
  background: var(--bg-subtle);
}

.report-wide .report-table th:first-child {
  z-index: 5;
  background: var(--bg-subtle);
}

.report-table th,
.report-table td {
  box-sizing: border-box;
  border-bottom: 1px solid var(--border);
  border-right: 1px solid var(--border);
  padding: 0.6rem 0.9rem;
  text-align: left;
}

.report-table th:last-child,
.report-table td:last-child {
  border-right: none;
}

.report-table tbody tr:last-child td {
  border-bottom: none;
}

.report-table .row-total td {
  background: var(--bg-subtle) !important;
  border-top: 2px solid var(--border-strong);
  font-size: 0.95rem;
}

.diff-cell.diff-match { color: var(--detail-positive-text); }
.diff-cell.diff-close { color: var(--warning-text); }
.diff-cell.diff-mismatch { color: var(--detail-negative-text); font-weight: 600; }
.diff-pct { font-size: 0.75em; opacity: 0.75; margin-left: 0.25rem; }

.comment-cell {
  font-size: 0.8rem;
  color: var(--text-muted);
  max-width: 280px;
  white-space: normal;
  line-height: 1.35;
}

.row-missing td {
  background: var(--warning-bg) !important;
  color: var(--warning-text);
}

.report-table th {
  background: var(--bg-subtle);
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--text);
}

.table-toggle {
  cursor: pointer;
}

.table-default-checkbox {
  margin-right: 8px;
  cursor: pointer;
  vertical-align: middle;
}

.table-toggle-arrow {
  margin-right: 6px;
  font-size: 0.75em;
}

.table-toggle:hover th {
  background: var(--bg-hover);
}

.report-table .num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.report-table .source {
  color: var(--text-faint);
  font-size: 0.8rem;
}

.report-table .row-bold td {
  background: var(--bg-subtle);
}

.report-table .row-blue td {
  background: var(--accent-soft);
  color: var(--accent);
}

.report-table .row-expandable {
  cursor: pointer;
}

.report-table tbody tr td {
  background: var(--bg-card);
  color: var(--text);
}

.report-table .row-detail-header td {
  background: var(--detail-header-bg) !important;
  color: var(--text-faint);
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
}

.report-table .row-detail td {
  background: var(--detail-bg) !important;
  color: var(--text-muted);
  font-size: 0.85rem;
}

.report-table .row-detail .detail-name,
.report-table .row-detail-header .detail-name {
  padding-left: 2rem;
}

.detail-col-label {
  text-align: right;
}

.report-table .row-detail-group td {
  background: var(--detail-group-bg) !important;
  color: var(--text-muted);
  font-size: 0.8rem;
  padding: 0.3rem 0.75rem 0.3rem 2rem;
}

.report-table .row-detail .detail-indented {
  padding-left: 3rem;
}

.report-table .row-detail.detail-positive td {
  background: var(--detail-positive-bg) !important;
  color: var(--detail-positive-text);
}

.report-table .row-detail.detail-negative td {
  background: var(--detail-negative-bg) !important;
  color: var(--detail-negative-text);
}

.report-table .row-detail.detail-expandable {
  cursor: pointer;
}

.report-table .row-detail.detail-expandable td {
  text-decoration: underline;
  text-decoration-style: dotted;
}

.report-table .row-sub-detail td {
  background: var(--detail-bg) !important;
  color: var(--text-muted);
  font-size: 0.8rem;
  font-style: italic;
}

.report-table .row-sub-detail .sub-detail-name {
  padding-left: 4rem;
}

/* Overall page - clickable cells */
.cell-clickable {
  cursor: pointer;
}

.cell-clickable:hover {
  background: var(--accent-soft) !important;
}

.cell-formula {
  cursor: pointer;
}

/* Hover highlight for formula dependencies */
.row-highlight-plus td {
  background: var(--detail-positive-bg) !important;
  color: var(--detail-positive-text);
}

.row-highlight-minus td {
  background: var(--detail-negative-bg) !important;
  color: var(--detail-negative-text);
}

/* Detail panel (slide-in from right) */
.panel-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 100;
}

.detail-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 520px;
  max-width: 90vw;
  height: 100vh;
  background: var(--bg-card);
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 101;
  overflow-y: auto;
  padding: 1.5rem;
  animation: slideIn 0.2s ease-out;
}

@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}

.detail-panel-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
}

.detail-panel-header h3 {
  margin: 0;
  flex: 1 1;
  font-size: 1rem;
}

.detail-panel-label {
  background: var(--accent);
  color: #fff;
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
}

.detail-panel-close {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: var(--text-muted);
  padding: 0.25rem;
}

.detail-panel-close:hover {
  color: var(--text);
}

.detail-panel-value {
  font-size: 1.5rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  margin-bottom: 1rem;
}

.detail-panel-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
  margin-bottom: 1rem;
  font-size: 0.85rem;
  color: var(--text);
}

.detail-panel-source {
  color: var(--text-muted);
  font-size: 0.85rem;
  margin-bottom: 1rem;
  word-break: break-word;
}

.detail-panel-details table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}

.detail-panel-details th,
.detail-panel-details td {
  border: 1px solid var(--border);
  padding: 0.4rem 0.5rem;
  text-align: left;
}

.detail-panel-details th {
  background: var(--bg-subtle);
  color: var(--text-muted);
  font-weight: 600;
}

.detail-panel-details .num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.detail-panel-details .source {
  color: var(--text-faint);
  font-size: 0.75rem;
  max-width: 140px;
  word-break: break-all;
}

.detail-panel-details .detail-negative td {
  color: var(--detail-negative-text);
}

/* Overall page toolbar & editor */
.overall-toolbar {
  margin-bottom: 1rem;
}

.overall-toolbar-buttons {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
}

.overall-cache-info {
  margin-left: 0.5rem;
  color: var(--text-faint);
  font-size: 0.8rem;
}

.overall-edit-btn {
  padding: 0.4rem 1rem;
  border: 1px solid var(--border-strong);
  border-radius: 6px;
  background: var(--bg-card);
  cursor: pointer;
  font-size: 0.875rem;
  color: var(--text);
}

.overall-edit-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.overall-settings-wrap {
  position: relative;
  z-index: 30;
}

.overall-settings-panel {
  position: absolute;
  top: calc(100% + 0.4rem);
  left: 0;
  /* Above .overall-sticky-header (z-index 20): the sticky table headers come later in the DOM,
     so at an equal z-index they would paint over this dropdown. Stays below the modals (100/101). */
  z-index: 30;
  min-width: 280px;
  padding: 0.75rem;
  border: 1px solid var(--border-strong);
  border-radius: 8px;
  background: var(--bg-card);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.overall-settings-row {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.85rem;
  color: var(--text);
}

.overall-settings-row input {
  padding: 0.4rem 0.6rem;
  border: 1px solid var(--border-strong);
  border-radius: 4px;
  background: var(--bg);
  color: var(--text);
  font-family: inherit;
}

.overall-settings-actions {
  display: flex;
  gap: 0.5rem;
}

.overall-settings-actions button {
  padding: 0.4rem 0.9rem;
  border: 1px solid var(--border-strong);
  border-radius: 6px;
  background: var(--bg-card);
  cursor: pointer;
  font-size: 0.85rem;
}

.overall-settings-actions button:first-child {
  background: var(--accent);
  color: white;
  border-color: var(--accent);
}

.overall-settings-actions button:first-child:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.overall-editor {
  border: 2px solid var(--border-strong);
  border-radius: 8px;
  padding: 1rem;
  background: var(--bg-subtle);
}

.overall-editor h3 {
  margin: 0 0 0.75rem;
  font-size: 1rem;
}

.overall-columns-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 0.75rem;
}

.overall-column-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.4rem 0.75rem;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 6px;
}

.overall-column-label {
  font-weight: 600;
  min-width: 60px;
}

.overall-column-meta {
  color: var(--text-muted);
  font-size: 0.8rem;
  flex: 1 1;
}

.overall-add-row {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.overall-add-row select,
.overall-add-row input {
  padding: 0.35rem 0.5rem;
  border: 1px solid var(--border);
  border-radius: 6px;
  font-size: 0.85rem;
}

.overall-add-row button {
  padding: 0.35rem 0.75rem;
  border: none;
  border-radius: 6px;
  background: #2563eb;
  color: white;
  cursor: pointer;
  font-size: 1rem;
}

.overall-add-row button:disabled {
  background: #93c5fd;
  cursor: not-allowed;
}

.overall-editor-actions {
  display: flex;
  gap: 0.5rem;
}

.overall-editor-actions button {
  padding: 0.4rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
}

.overall-editor-actions button:first-child {
  background: #2563eb;
  color: white;
}

.overall-editor-actions button:first-child:disabled {
  background: #93c5fd;
}

.overall-editor-actions button:last-child {
  background: var(--border);
  color: var(--text);
}

/* Config reset button */
.config-reset-btn {
  margin-left: 0.75rem;
  padding: 0.25rem 0.75rem;
  border: 1px solid #f59e0b;
  border-radius: 6px;
  background: #fef3c7;
  color: #92400e;
  cursor: pointer;
  font-size: 0.8rem;
}

.config-reset-btn:hover {
  background: #fde68a;
}

/* Row edit button (pencil icon) */
.row-edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--text-faint);
  margin-left: 0.5rem;
  padding: 0 0.25rem;
  vertical-align: middle;
}

.row-edit-btn:hover {
  color: var(--accent);
}

/* Config editor panel */
.config-editor-panel {
  width: 600px;
}

.config-lookups-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 1rem;
  max-height: 40vh;
  overflow-y: auto;
}

.config-lookup-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.6rem;
  background: var(--bg-subtle);
  border: 1px solid var(--border);
  border-radius: 6px;
  font-size: 0.8rem;
}

.config-lookup-static {
  background: #fef3c7;
  border-color: #f59e0b;
}

.config-lookup-info {
  flex: 1 1;
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem 0.75rem;
  align-items: center;
}

.config-lookup-file {
  font-weight: 600;
  color: #1e40af;
}

.config-lookup-account {
  color: var(--text);
}

.config-lookup-after {
  color: var(--text-muted);
  font-style: italic;
  font-size: 0.75rem;
}

.config-lookup-col {
  color: var(--text-faint);
  font-size: 0.75rem;
}

.config-lookup-sign {
  font-weight: 700;
  font-size: 1rem;
}

.sign-plus {
  color: #16a34a;
}

.sign-minus {
  color: #dc2626;
}

.config-add-lookup {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 0.75rem;
  background: var(--bg-subtle);
  margin-bottom: 1rem;
}

.config-add-lookup h4 {
  margin: 0 0 0.5rem;
  font-size: 0.85rem;
  color: var(--text);
}

.config-add-form {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.config-add-form select,
.config-add-form input {
  padding: 0.3rem 0.4rem;
  border: 1px solid var(--border);
  border-radius: 6px;
  font-size: 0.8rem;
  min-width: 0;
}

.config-add-form select {
  max-width: 180px;
}

.config-add-form input {
  flex: 1 1;
  min-width: 100px;
}

.config-add-form button {
  padding: 0.3rem 0.75rem;
  border: none;
  border-radius: 6px;
  background: #2563eb;
  color: white;
  cursor: pointer;
  font-size: 0.8rem;
}

.config-add-form button:disabled {
  background: #93c5fd;
  cursor: not-allowed;
}

.config-editor-actions {
  display: flex;
  gap: 0.5rem;
}

.config-editor-actions button {
  padding: 0.4rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
}

.config-editor-actions button:first-child {
  background: #2563eb;
  color: white;
}

.config-editor-actions button:first-child:disabled {
  background: #93c5fd;
}

.config-editor-actions button:last-child {
  background: var(--border);
  color: var(--text);
}

/* Overall totals row */
.overall-totals-row {
  border-top: 2px solid #1e293b;
  background: var(--bg-subtle);
}

.overall-totals-row td {
  font-weight: 700;
}

/* Сверка суммы расшифровки со строкой расходов в СГД */
.overall-recon-row td {
  font-size: 12px;
  padding-top: 2px;
  padding-bottom: 4px;
  border-top: none;
  color: var(--text-muted);
}

.overall-recon-row .recon-ok {
  color: #15803d;
  font-weight: 700;
}

.overall-recon-row .recon-bad {
  color: #b91c1c;
  font-weight: 700;
}

.overall-recon-row .recon-empty {
  opacity: 0.4;
}

/* Лукап, чья ячейка уже посчитана другим лукапом той же строки — показан с нулём */
.detail-dup {
  display: inline-block;
  margin-left: 6px;
  padding: 0 5px;
  border-radius: 3px;
  background: var(--warning-bg);
  color: var(--warning-text);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  vertical-align: middle;
}

/* Reconciliation badges: does each breakdown table add up to its СГД row, and which period
   length the numbers were built with. Both used to be checked by hand. */
.report-checks {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.check-badge {
  display: inline-flex;
  align-items: baseline;
  gap: 0.45rem;
  padding: 0.35rem 0.75rem;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: var(--bg-card);
  font-size: 0.8rem;
}

.check-mark {
  font-weight: 700;
}

.check-name {
  color: var(--text-muted);
}

.check-value {
  font-weight: 600;
}

.check-badge.is-ok {
  border-color: rgba(22, 163, 74, 0.45);
}

.check-badge.is-ok .check-mark,
.check-badge.is-ok .check-value {
  color: #16a34a;
}

.check-badge.is-bad {
  border-color: var(--warning-border);
  background: var(--warning-bg);
}

.check-badge.is-bad .check-mark,
.check-badge.is-bad .check-value {
  color: var(--warning-text);
}

.check-badge.is-unknown .check-mark,
.check-badge.is-info .check-mark {
  color: var(--text-faint);
}

/* ==========================================================================
   Overall → value detail panel. The old layout squeezed five table columns into a 520px
   drawer, so статья names and cell addresses wrapped into noise. Cards instead: one component
   per row, full width for the name, value and share on the right.
   Base .detail-panel* classes stay as they are — Home and Master use them too.
   ========================================================================== */

.detail-panel.detail-panel-wide {
  width: 640px;
}

.dv-summary {
  margin: -0.5rem 0 0.75rem;
  color: var(--text-muted);
  font-size: 0.85rem;
}

.dv-warn {
  color: var(--warning-text);
  font-weight: 600;
}

.dv-formula {
  margin-bottom: 0.75rem;
  padding: 0.5rem 0.7rem;
  border-radius: var(--radius-sm);
  background: var(--bg-subtle);
  font-size: 0.85rem;
  word-break: break-word;
}

.dv-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.dv-item {
  padding: 0.55rem 0.7rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-card);
}

.dv-item-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.dv-item-name {
  font-size: 0.875rem;
  font-weight: 500;
  overflow-wrap: anywhere;
}

.dv-item-value {
  flex-shrink: 0;
  font-size: 0.95rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.dv-item.is-negative .dv-item-value {
  color: #dc2626;
}

/* Proportional bar: lets the eye find the component that drives the number. */
.dv-bar {
  height: 3px;
  margin: 0.4rem 0;
  border-radius: 2px;
  background: var(--bg-subtle);
  overflow: hidden;
}

.dv-bar span {
  display: block;
  height: 100%;
  background: var(--accent);
  opacity: 0.55;
}

.dv-item.is-negative .dv-bar span {
  background: #dc2626;
}

.dv-item-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.3rem;
}

.dv-chip {
  padding: 1px 6px;
  border-radius: 4px;
  background: var(--bg-subtle);
  color: var(--text-muted);
  font-size: 0.72rem;
  white-space: nowrap;
}

.dv-chip-soft {
  background: none;
  color: var(--text-faint);
}

.dv-share {
  margin-left: auto;
  color: var(--text-faint);
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
}

.dv-missing {
  margin-bottom: 1rem;
  padding: 0.7rem 0.8rem;
  border: 1px solid var(--warning-border);
  border-radius: var(--radius-sm);
  background: var(--warning-bg);
  color: var(--warning-text);
}

.dv-missing-title {
  margin-bottom: 0.4rem;
  font-size: 0.8rem;
  font-weight: 700;
}

.dv-missing-item {
  display: flex;
  flex-direction: column;
  padding: 0.25rem 0;
  font-size: 0.8rem;
}

.dv-missing-src {
  opacity: 0.75;
  font-size: 0.72rem;
  overflow-wrap: anywhere;
}

.dv-missing-hint {
  margin-top: 0.4rem;
  opacity: 0.8;
  font-size: 0.72rem;
}

.dv-total {
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
  padding: 0.6rem 0.7rem;
  border-radius: var(--radius-sm);
  background: var(--bg-subtle);
  font-size: 0.85rem;
}

.dv-total-value {
  margin-left: auto;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.dv-total-mark {
  font-size: 0.75rem;
  font-weight: 600;
}

.dv-total.is-ok .dv-total-mark {
  color: #16a34a;
}

.dv-total.is-bad .dv-total-mark {
  color: var(--warning-text);
}

/* Overall: per-column reconciliation at a glance — which companies to trust in this period. */
.ov-checks {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 1rem;
}

.ov-checks-title {
  margin-right: 0.2rem;
  color: var(--text-muted);
  font-size: 0.8rem;
}

.ov-check {
  display: inline-flex;
  align-items: baseline;
  gap: 0.35rem;
  padding: 0.25rem 0.6rem;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: var(--bg-card);
  font-size: 0.8rem;
  cursor: help;
  white-space: pre-line;
}

.ov-check-mark {
  font-weight: 700;
}

.ov-check.is-ok {
  border-color: rgba(22, 163, 74, 0.45);
}

.ov-check.is-ok .ov-check-mark {
  color: #16a34a;
}

.ov-check.is-bad {
  border-color: var(--warning-border);
  background: var(--warning-bg);
  color: var(--warning-text);
}

.ov-check.is-unknown .ov-check-mark {
  color: var(--text-faint);
}

.ov-check-diff {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

/* Anchor rows («Расходы по ТБ», «Административные расходы») carry the total of their breakdown
   table right under the value, so a drift is visible without opening anything. */
.row-check {
  display: block;
  margin-top: 0.15rem;
  font-size: 0.72rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.row-check.is-ok {
  color: #16a34a;
}

.row-check.is-bad {
  color: var(--warning-text);
}

.row-check-note {
  display: block;
  margin-top: 0.15rem;
  color: var(--text-faint);
  font-size: 0.7rem;
}

.report-table tr.row-tied td:first-child {
  box-shadow: inset 3px 0 0 #16a34a;
}

.report-table tr.row-untied td:first-child {
  box-shadow: inset 3px 0 0 var(--warning-border);
}

.report-table tr.row-untied td {
  background: var(--warning-bg);
}

/* Overall: breakdown total under the value of the two anchor rows. */
.report-table td.num .cell-check {
  display: block;
  margin-top: 0.1rem;
  font-size: 0.68rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  cursor: help;
}

.cell-check.is-ok {
  color: #16a34a;
}

.cell-check.is-bad {
  color: var(--warning-text);
}

/* Источник данных сменили, но ответ ещё не пришёл: показываем старую таблицу
   приглушённой, чтобы её нельзя было принять за актуальную. */
.overall-stale-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding: 9px 14px;
  border: 1px solid var(--warning-border);
  border-left-width: 3px;
  border-radius: var(--radius-sm);
  background: var(--warning-bg);
  color: var(--warning-text);
  font-size: 13px;
}

.overall-stale-spinner {
  display: inline-block;
  animation: overall-stale-spin 1.1s linear infinite;
  font-size: 15px;
}

@keyframes overall-stale-spin {
  to { transform: rotate(360deg); }
}

@media (prefers-reduced-motion: reduce) {
  .overall-stale-spinner { animation: none; }
}

.overall-tables.is-stale {
  opacity: 0.45;
  filter: grayscale(0.35);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  transition: opacity 0.15s ease;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA,iFAAiF;AACjF;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,8CAA8C;EAC9C,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;gFACgF;AAChF;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;;EAEE,sBAAsB;EACtB,sCAAsC;EACtC,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,wBAAwB,kCAAkC,EAAE;AAC5D,wBAAwB,0BAA0B,EAAE;AACpD,2BAA2B,kCAAkC,EAAE,gBAAgB,EAAE;AACjF,YAAY,iBAAiB,EAAE,aAAa,EAAE,oBAAoB,EAAE;;AAEpE;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,wBAAwB;EACxB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,wBAAwB;EACxB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;EACE,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;EACE,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP;oGACkG;EAClG,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,mFAAmF;AACnF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;yEACyE;AACzE;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;EAC/B,oBAAoB;EACpB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;;+EAK+E;;AAE/E;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uCAAuC;EACvC,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8FAA8F;AAC9F;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;EACpB,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;iFACiF;AACjF;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,qEAAqE;AACrE;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;8DAC8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;EACvC,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,yBAAyB,eAAe,EAAE;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,8BAA8B;AAChC","sourcesContent":[".report-section {\n  margin-bottom: 0;\n}\n\n/* Overall page: allow horizontal scroll on small displays instead of squashing */\n.report-table-scroll {\n  overflow-x: auto;\n  margin-bottom: 1rem;\n  -webkit-overflow-scrolling: touch;\n}\n\n.report-table-scroll .report-table {\n  margin-bottom: 0;\n}\n\n.overall-table-block {\n  position: relative;\n  margin-bottom: 1rem;\n}\n\n.overall-table-block .report-table-scroll {\n  margin-bottom: 0;\n}\n\n.overall-table-block .report-table {\n  width: auto;\n  border-radius: 0 0 var(--radius) var(--radius);\n}\n\n.overall-sticky-header {\n  box-sizing: border-box;\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  display: flex;\n  max-width: 100%;\n  background: var(--bg-subtle);\n  border: 1px solid var(--border);\n  border-bottom: none;\n  border-radius: var(--radius) var(--radius) 0 0;\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n\n.overall-sticky-header-name {\n  box-sizing: border-box;\n  width: 280px;\n  min-width: 280px;\n  max-width: 280px;\n  padding: 0.6rem 0.9rem;\n  border-right: 1px solid var(--border);\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: var(--text);\n  cursor: pointer;\n  white-space: normal;\n  overflow-wrap: break-word;\n}\n\n.overall-sticky-header-scroll {\n  flex: 1;\n  overflow: hidden;\n}\n\n.overall-sticky-header-cols {\n  display: flex;\n  will-change: transform;\n}\n\n.overall-sticky-header-col {\n  box-sizing: border-box;\n  width: 170px;\n  min-width: 170px;\n  max-width: 170px;\n  padding: 0.6rem 0.9rem;\n  border-right: 1px solid var(--border);\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: var(--text);\n  text-align: left;\n}\n\n.overall-sticky-header-col:last-child {\n  border-right: none;\n}\n\n/* Report warnings */\n.report-warnings {\n  background: var(--warning-bg);\n  border: 1px solid var(--warning-border);\n  border-radius: 6px;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  font-size: 0.85rem;\n  color: var(--warning-text);\n}\n\n.report-warnings ul {\n  margin: 0.4rem 0 0;\n  padding-left: 1.25rem;\n}\n\n.report-warnings li {\n  margin-bottom: 0.2rem;\n}\n\n.warning-table {\n  font-weight: 600;\n}\n\n.warning-source {\n  color: var(--warning-text);\n  font-size: 0.75rem;\n  margin-left: 0.5rem;\n}\n\n.report-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin-bottom: 1rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  overflow: hidden;\n}\n\n/* Overall page: align columns across multiple tables.\n   First column (row name) has a fixed share; remaining columns split equally. */\n.report-wide .report-table {\n  table-layout: fixed;\n  overflow: visible;\n}\n\n.report-wide .report-table-scroll {\n  position: relative;\n  max-width: 100%;\n}\n.report-wide .report-table th:first-child,\n.report-wide .report-table td:first-child {\n  position: sticky;\n  left: 0;\n  width: 280px;\n  min-width: 280px;\n  max-width: 280px;\n  z-index: 2;\n  background: var(--bg-card);\n  white-space: normal;\n  overflow-wrap: break-word;\n}\n\n.report-wide .report-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 4;\n  background: var(--bg-subtle);\n}\n\n.report-wide .report-table th:first-child {\n  z-index: 5;\n  background: var(--bg-subtle);\n}\n\n.report-table th,\n.report-table td {\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--border);\n  border-right: 1px solid var(--border);\n  padding: 0.6rem 0.9rem;\n  text-align: left;\n}\n\n.report-table th:last-child,\n.report-table td:last-child {\n  border-right: none;\n}\n\n.report-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.report-table .row-total td {\n  background: var(--bg-subtle) !important;\n  border-top: 2px solid var(--border-strong);\n  font-size: 0.95rem;\n}\n\n.diff-cell.diff-match { color: var(--detail-positive-text); }\n.diff-cell.diff-close { color: var(--warning-text); }\n.diff-cell.diff-mismatch { color: var(--detail-negative-text); font-weight: 600; }\n.diff-pct { font-size: 0.75em; opacity: 0.75; margin-left: 0.25rem; }\n\n.comment-cell {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  max-width: 280px;\n  white-space: normal;\n  line-height: 1.35;\n}\n\n.row-missing td {\n  background: var(--warning-bg) !important;\n  color: var(--warning-text);\n}\n\n.report-table th {\n  background: var(--bg-subtle);\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: var(--text);\n}\n\n.table-toggle {\n  cursor: pointer;\n}\n\n.table-default-checkbox {\n  margin-right: 8px;\n  cursor: pointer;\n  vertical-align: middle;\n}\n\n.table-toggle-arrow {\n  margin-right: 6px;\n  font-size: 0.75em;\n}\n\n.table-toggle:hover th {\n  background: var(--bg-hover);\n}\n\n.report-table .num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.report-table .source {\n  color: var(--text-faint);\n  font-size: 0.8rem;\n}\n\n.report-table .row-bold td {\n  background: var(--bg-subtle);\n}\n\n.report-table .row-blue td {\n  background: var(--accent-soft);\n  color: var(--accent);\n}\n\n.report-table .row-expandable {\n  cursor: pointer;\n}\n\n.report-table tbody tr td {\n  background: var(--bg-card);\n  color: var(--text);\n}\n\n.report-table .row-detail-header td {\n  background: var(--detail-header-bg) !important;\n  color: var(--text-faint);\n  font-size: 0.75rem;\n  padding: 0.25rem 0.75rem;\n}\n\n.report-table .row-detail td {\n  background: var(--detail-bg) !important;\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.report-table .row-detail .detail-name,\n.report-table .row-detail-header .detail-name {\n  padding-left: 2rem;\n}\n\n.detail-col-label {\n  text-align: right;\n}\n\n.report-table .row-detail-group td {\n  background: var(--detail-group-bg) !important;\n  color: var(--text-muted);\n  font-size: 0.8rem;\n  padding: 0.3rem 0.75rem 0.3rem 2rem;\n}\n\n.report-table .row-detail .detail-indented {\n  padding-left: 3rem;\n}\n\n.report-table .row-detail.detail-positive td {\n  background: var(--detail-positive-bg) !important;\n  color: var(--detail-positive-text);\n}\n\n.report-table .row-detail.detail-negative td {\n  background: var(--detail-negative-bg) !important;\n  color: var(--detail-negative-text);\n}\n\n.report-table .row-detail.detail-expandable {\n  cursor: pointer;\n}\n\n.report-table .row-detail.detail-expandable td {\n  text-decoration: underline;\n  text-decoration-style: dotted;\n}\n\n.report-table .row-sub-detail td {\n  background: var(--detail-bg) !important;\n  color: var(--text-muted);\n  font-size: 0.8rem;\n  font-style: italic;\n}\n\n.report-table .row-sub-detail .sub-detail-name {\n  padding-left: 4rem;\n}\n\n/* Overall page - clickable cells */\n.cell-clickable {\n  cursor: pointer;\n}\n\n.cell-clickable:hover {\n  background: var(--accent-soft) !important;\n}\n\n.cell-formula {\n  cursor: pointer;\n}\n\n/* Hover highlight for formula dependencies */\n.row-highlight-plus td {\n  background: var(--detail-positive-bg) !important;\n  color: var(--detail-positive-text);\n}\n\n.row-highlight-minus td {\n  background: var(--detail-negative-bg) !important;\n  color: var(--detail-negative-text);\n}\n\n/* Detail panel (slide-in from right) */\n.panel-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 100;\n}\n\n.detail-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 520px;\n  max-width: 90vw;\n  height: 100vh;\n  background: var(--bg-card);\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n  z-index: 101;\n  overflow-y: auto;\n  padding: 1.5rem;\n  animation: slideIn 0.2s ease-out;\n}\n\n@keyframes slideIn {\n  from { transform: translateX(100%); }\n  to { transform: translateX(0); }\n}\n\n.detail-panel-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.detail-panel-header h3 {\n  margin: 0;\n  flex: 1;\n  font-size: 1rem;\n}\n\n.detail-panel-label {\n  background: var(--accent);\n  color: #fff;\n  padding: 0.2rem 0.6rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.detail-panel-close {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n  color: var(--text-muted);\n  padding: 0.25rem;\n}\n\n.detail-panel-close:hover {\n  color: var(--text);\n}\n\n.detail-panel-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  margin-bottom: 1rem;\n}\n\n.detail-panel-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 1.5rem;\n  margin-bottom: 1rem;\n  font-size: 0.85rem;\n  color: var(--text);\n}\n\n.detail-panel-source {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n  margin-bottom: 1rem;\n  word-break: break-word;\n}\n\n.detail-panel-details table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8rem;\n}\n\n.detail-panel-details th,\n.detail-panel-details td {\n  border: 1px solid var(--border);\n  padding: 0.4rem 0.5rem;\n  text-align: left;\n}\n\n.detail-panel-details th {\n  background: var(--bg-subtle);\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n.detail-panel-details .num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.detail-panel-details .source {\n  color: var(--text-faint);\n  font-size: 0.75rem;\n  max-width: 140px;\n  word-break: break-all;\n}\n\n.detail-panel-details .detail-negative td {\n  color: var(--detail-negative-text);\n}\n\n/* Overall page toolbar & editor */\n.overall-toolbar {\n  margin-bottom: 1rem;\n}\n\n.overall-toolbar-buttons {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.overall-cache-info {\n  margin-left: 0.5rem;\n  color: var(--text-faint);\n  font-size: 0.8rem;\n}\n\n.overall-edit-btn {\n  padding: 0.4rem 1rem;\n  border: 1px solid var(--border-strong);\n  border-radius: 6px;\n  background: var(--bg-card);\n  cursor: pointer;\n  font-size: 0.875rem;\n  color: var(--text);\n}\n\n.overall-edit-btn:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.overall-settings-wrap {\n  position: relative;\n  z-index: 30;\n}\n\n.overall-settings-panel {\n  position: absolute;\n  top: calc(100% + 0.4rem);\n  left: 0;\n  /* Above .overall-sticky-header (z-index 20): the sticky table headers come later in the DOM,\n     so at an equal z-index they would paint over this dropdown. Stays below the modals (100/101). */\n  z-index: 30;\n  min-width: 280px;\n  padding: 0.75rem;\n  border: 1px solid var(--border-strong);\n  border-radius: 8px;\n  background: var(--bg-card);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.overall-settings-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.85rem;\n  color: var(--text);\n}\n\n.overall-settings-row input {\n  padding: 0.4rem 0.6rem;\n  border: 1px solid var(--border-strong);\n  border-radius: 4px;\n  background: var(--bg);\n  color: var(--text);\n  font-family: inherit;\n}\n\n.overall-settings-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.overall-settings-actions button {\n  padding: 0.4rem 0.9rem;\n  border: 1px solid var(--border-strong);\n  border-radius: 6px;\n  background: var(--bg-card);\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.overall-settings-actions button:first-child {\n  background: var(--accent);\n  color: white;\n  border-color: var(--accent);\n}\n\n.overall-settings-actions button:first-child:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.overall-editor {\n  border: 2px solid var(--border-strong);\n  border-radius: 8px;\n  padding: 1rem;\n  background: var(--bg-subtle);\n}\n\n.overall-editor h3 {\n  margin: 0 0 0.75rem;\n  font-size: 1rem;\n}\n\n.overall-columns-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-bottom: 0.75rem;\n}\n\n.overall-column-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.4rem 0.75rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n}\n\n.overall-column-label {\n  font-weight: 600;\n  min-width: 60px;\n}\n\n.overall-column-meta {\n  color: var(--text-muted);\n  font-size: 0.8rem;\n  flex: 1;\n}\n\n.overall-add-row {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.overall-add-row select,\n.overall-add-row input {\n  padding: 0.35rem 0.5rem;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  font-size: 0.85rem;\n}\n\n.overall-add-row button {\n  padding: 0.35rem 0.75rem;\n  border: none;\n  border-radius: 6px;\n  background: #2563eb;\n  color: white;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.overall-add-row button:disabled {\n  background: #93c5fd;\n  cursor: not-allowed;\n}\n\n.overall-editor-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.overall-editor-actions button {\n  padding: 0.4rem 1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.overall-editor-actions button:first-child {\n  background: #2563eb;\n  color: white;\n}\n\n.overall-editor-actions button:first-child:disabled {\n  background: #93c5fd;\n}\n\n.overall-editor-actions button:last-child {\n  background: var(--border);\n  color: var(--text);\n}\n\n/* Config reset button */\n.config-reset-btn {\n  margin-left: 0.75rem;\n  padding: 0.25rem 0.75rem;\n  border: 1px solid #f59e0b;\n  border-radius: 6px;\n  background: #fef3c7;\n  color: #92400e;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.config-reset-btn:hover {\n  background: #fde68a;\n}\n\n/* Row edit button (pencil icon) */\n.row-edit-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.85rem;\n  color: var(--text-faint);\n  margin-left: 0.5rem;\n  padding: 0 0.25rem;\n  vertical-align: middle;\n}\n\n.row-edit-btn:hover {\n  color: var(--accent);\n}\n\n/* Config editor panel */\n.config-editor-panel {\n  width: 600px;\n}\n\n.config-lookups-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-bottom: 1rem;\n  max-height: 40vh;\n  overflow-y: auto;\n}\n\n.config-lookup-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.6rem;\n  background: var(--bg-subtle);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  font-size: 0.8rem;\n}\n\n.config-lookup-static {\n  background: #fef3c7;\n  border-color: #f59e0b;\n}\n\n.config-lookup-info {\n  flex: 1;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem 0.75rem;\n  align-items: center;\n}\n\n.config-lookup-file {\n  font-weight: 600;\n  color: #1e40af;\n}\n\n.config-lookup-account {\n  color: var(--text);\n}\n\n.config-lookup-after {\n  color: var(--text-muted);\n  font-style: italic;\n  font-size: 0.75rem;\n}\n\n.config-lookup-col {\n  color: var(--text-faint);\n  font-size: 0.75rem;\n}\n\n.config-lookup-sign {\n  font-weight: 700;\n  font-size: 1rem;\n}\n\n.sign-plus {\n  color: #16a34a;\n}\n\n.sign-minus {\n  color: #dc2626;\n}\n\n.config-add-lookup {\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 0.75rem;\n  background: var(--bg-subtle);\n  margin-bottom: 1rem;\n}\n\n.config-add-lookup h4 {\n  margin: 0 0 0.5rem;\n  font-size: 0.85rem;\n  color: var(--text);\n}\n\n.config-add-form {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.config-add-form select,\n.config-add-form input {\n  padding: 0.3rem 0.4rem;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  font-size: 0.8rem;\n  min-width: 0;\n}\n\n.config-add-form select {\n  max-width: 180px;\n}\n\n.config-add-form input {\n  flex: 1;\n  min-width: 100px;\n}\n\n.config-add-form button {\n  padding: 0.3rem 0.75rem;\n  border: none;\n  border-radius: 6px;\n  background: #2563eb;\n  color: white;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.config-add-form button:disabled {\n  background: #93c5fd;\n  cursor: not-allowed;\n}\n\n.config-editor-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.config-editor-actions button {\n  padding: 0.4rem 1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.config-editor-actions button:first-child {\n  background: #2563eb;\n  color: white;\n}\n\n.config-editor-actions button:first-child:disabled {\n  background: #93c5fd;\n}\n\n.config-editor-actions button:last-child {\n  background: var(--border);\n  color: var(--text);\n}\n\n/* Overall totals row */\n.overall-totals-row {\n  border-top: 2px solid #1e293b;\n  background: var(--bg-subtle);\n}\n\n.overall-totals-row td {\n  font-weight: 700;\n}\n\n/* Сверка суммы расшифровки со строкой расходов в СГД */\n.overall-recon-row td {\n  font-size: 12px;\n  padding-top: 2px;\n  padding-bottom: 4px;\n  border-top: none;\n  color: var(--text-muted);\n}\n\n.overall-recon-row .recon-ok {\n  color: #15803d;\n  font-weight: 700;\n}\n\n.overall-recon-row .recon-bad {\n  color: #b91c1c;\n  font-weight: 700;\n}\n\n.overall-recon-row .recon-empty {\n  opacity: 0.4;\n}\n\n/* Лукап, чья ячейка уже посчитана другим лукапом той же строки — показан с нулём */\n.detail-dup {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 0 5px;\n  border-radius: 3px;\n  background: var(--warning-bg);\n  color: var(--warning-text);\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  vertical-align: middle;\n}\n\n/* Reconciliation badges: does each breakdown table add up to its СГД row, and which period\n   length the numbers were built with. Both used to be checked by hand. */\n.report-checks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.check-badge {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0.45rem;\n  padding: 0.35rem 0.75rem;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  background: var(--bg-card);\n  font-size: 0.8rem;\n}\n\n.check-mark {\n  font-weight: 700;\n}\n\n.check-name {\n  color: var(--text-muted);\n}\n\n.check-value {\n  font-weight: 600;\n}\n\n.check-badge.is-ok {\n  border-color: rgba(22, 163, 74, 0.45);\n}\n\n.check-badge.is-ok .check-mark,\n.check-badge.is-ok .check-value {\n  color: #16a34a;\n}\n\n.check-badge.is-bad {\n  border-color: var(--warning-border);\n  background: var(--warning-bg);\n}\n\n.check-badge.is-bad .check-mark,\n.check-badge.is-bad .check-value {\n  color: var(--warning-text);\n}\n\n.check-badge.is-unknown .check-mark,\n.check-badge.is-info .check-mark {\n  color: var(--text-faint);\n}\n\n/* ==========================================================================\n   Overall → value detail panel. The old layout squeezed five table columns into a 520px\n   drawer, so статья names and cell addresses wrapped into noise. Cards instead: one component\n   per row, full width for the name, value and share on the right.\n   Base .detail-panel* classes stay as they are — Home and Master use them too.\n   ========================================================================== */\n\n.detail-panel.detail-panel-wide {\n  width: 640px;\n}\n\n.dv-summary {\n  margin: -0.5rem 0 0.75rem;\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.dv-warn {\n  color: var(--warning-text);\n  font-weight: 600;\n}\n\n.dv-formula {\n  margin-bottom: 0.75rem;\n  padding: 0.5rem 0.7rem;\n  border-radius: var(--radius-sm);\n  background: var(--bg-subtle);\n  font-size: 0.85rem;\n  word-break: break-word;\n}\n\n.dv-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.dv-item {\n  padding: 0.55rem 0.7rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-card);\n}\n\n.dv-item-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.dv-item-name {\n  font-size: 0.875rem;\n  font-weight: 500;\n  overflow-wrap: anywhere;\n}\n\n.dv-item-value {\n  flex-shrink: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.dv-item.is-negative .dv-item-value {\n  color: #dc2626;\n}\n\n/* Proportional bar: lets the eye find the component that drives the number. */\n.dv-bar {\n  height: 3px;\n  margin: 0.4rem 0;\n  border-radius: 2px;\n  background: var(--bg-subtle);\n  overflow: hidden;\n}\n\n.dv-bar span {\n  display: block;\n  height: 100%;\n  background: var(--accent);\n  opacity: 0.55;\n}\n\n.dv-item.is-negative .dv-bar span {\n  background: #dc2626;\n}\n\n.dv-item-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.dv-chip {\n  padding: 1px 6px;\n  border-radius: 4px;\n  background: var(--bg-subtle);\n  color: var(--text-muted);\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.dv-chip-soft {\n  background: none;\n  color: var(--text-faint);\n}\n\n.dv-share {\n  margin-left: auto;\n  color: var(--text-faint);\n  font-size: 0.75rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.dv-missing {\n  margin-bottom: 1rem;\n  padding: 0.7rem 0.8rem;\n  border: 1px solid var(--warning-border);\n  border-radius: var(--radius-sm);\n  background: var(--warning-bg);\n  color: var(--warning-text);\n}\n\n.dv-missing-title {\n  margin-bottom: 0.4rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.dv-missing-item {\n  display: flex;\n  flex-direction: column;\n  padding: 0.25rem 0;\n  font-size: 0.8rem;\n}\n\n.dv-missing-src {\n  opacity: 0.75;\n  font-size: 0.72rem;\n  overflow-wrap: anywhere;\n}\n\n.dv-missing-hint {\n  margin-top: 0.4rem;\n  opacity: 0.8;\n  font-size: 0.72rem;\n}\n\n.dv-total {\n  display: flex;\n  align-items: baseline;\n  gap: 0.6rem;\n  padding: 0.6rem 0.7rem;\n  border-radius: var(--radius-sm);\n  background: var(--bg-subtle);\n  font-size: 0.85rem;\n}\n\n.dv-total-value {\n  margin-left: auto;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.dv-total-mark {\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.dv-total.is-ok .dv-total-mark {\n  color: #16a34a;\n}\n\n.dv-total.is-bad .dv-total-mark {\n  color: var(--warning-text);\n}\n\n/* Overall: per-column reconciliation at a glance — which companies to trust in this period. */\n.ov-checks {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem;\n  margin-bottom: 1rem;\n}\n\n.ov-checks-title {\n  margin-right: 0.2rem;\n  color: var(--text-muted);\n  font-size: 0.8rem;\n}\n\n.ov-check {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0.35rem;\n  padding: 0.25rem 0.6rem;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  background: var(--bg-card);\n  font-size: 0.8rem;\n  cursor: help;\n  white-space: pre-line;\n}\n\n.ov-check-mark {\n  font-weight: 700;\n}\n\n.ov-check.is-ok {\n  border-color: rgba(22, 163, 74, 0.45);\n}\n\n.ov-check.is-ok .ov-check-mark {\n  color: #16a34a;\n}\n\n.ov-check.is-bad {\n  border-color: var(--warning-border);\n  background: var(--warning-bg);\n  color: var(--warning-text);\n}\n\n.ov-check.is-unknown .ov-check-mark {\n  color: var(--text-faint);\n}\n\n.ov-check-diff {\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n}\n\n/* Anchor rows («Расходы по ТБ», «Административные расходы») carry the total of their breakdown\n   table right under the value, so a drift is visible without opening anything. */\n.row-check {\n  display: block;\n  margin-top: 0.15rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.row-check.is-ok {\n  color: #16a34a;\n}\n\n.row-check.is-bad {\n  color: var(--warning-text);\n}\n\n.row-check-note {\n  display: block;\n  margin-top: 0.15rem;\n  color: var(--text-faint);\n  font-size: 0.7rem;\n}\n\n.report-table tr.row-tied td:first-child {\n  box-shadow: inset 3px 0 0 #16a34a;\n}\n\n.report-table tr.row-untied td:first-child {\n  box-shadow: inset 3px 0 0 var(--warning-border);\n}\n\n.report-table tr.row-untied td {\n  background: var(--warning-bg);\n}\n\n/* Overall: breakdown total under the value of the two anchor rows. */\n.report-table td.num .cell-check {\n  display: block;\n  margin-top: 0.1rem;\n  font-size: 0.68rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  cursor: help;\n}\n\n.cell-check.is-ok {\n  color: #16a34a;\n}\n\n.cell-check.is-bad {\n  color: var(--warning-text);\n}\n\n/* Источник данных сменили, но ответ ещё не пришёл: показываем старую таблицу\n   приглушённой, чтобы её нельзя было принять за актуальную. */\n.overall-stale-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  padding: 9px 14px;\n  border: 1px solid var(--warning-border);\n  border-left-width: 3px;\n  border-radius: var(--radius-sm);\n  background: var(--warning-bg);\n  color: var(--warning-text);\n  font-size: 13px;\n}\n\n.overall-stale-spinner {\n  display: inline-block;\n  animation: overall-stale-spin 1.1s linear infinite;\n  font-size: 15px;\n}\n\n@keyframes overall-stale-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .overall-stale-spinner { animation: none; }\n}\n\n.overall-tables.is-stale {\n  opacity: 0.45;\n  filter: grayscale(0.35);\n  pointer-events: none;\n  user-select: none;\n  transition: opacity 0.15s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
